import Vue from "vue";
import {$t} from "@/i18n";
import {parse} from "date-fns";

window.get = function (obj, key, def) {
    // obj: object as object
    // key: value path as string, can use dot notation
    // def: default return value
    if (!obj) return typeof def !== "undefined" ? def : "";
    let ret = key.split(".").reduce(function (o, x) {
        return typeof o === "undefined" || o === null ? o : o[x];
    }, obj);
    return ret ? ret : def !== "undefined" ? def : "";
};
Vue.prototype.get = window.get;

// Default formatting
Vue.formatting = {
    culture: "en-GB",
    decimal_symbol: ".",
    currency_symbols: {
        "ILS": "\u20aa",
        "NOK": "kr",
        "AUD": "A$",
        "HRK": "kn",
        "JPY": "JP\u00a5",
        "CHF": "CHF",
        "CZK": "K\u010d",
        "PLN": "z\u0142",
        "HUF": "Ft",
        "RON": "RON",
        "EUR": "\u20ac",
        "BGN": "BGN",
        "SEK": "kr",
        "RUB": "\u20bd",
        "DKK": "kr",
        "USD": "US$",
        "TRY": "\u20ba",
        "GBP": "\u00a3"
    },
    thousands_symbol: ",",
    first_week_day: 1,
    locale_first_day_of_year: 0
};

export const CustomFormats = {
    numeric_month_with_short_year: 'numeric_month_with_short_year',
    month_name_with_full_year: 'month_name_with_full_year',
    short_month_name_with_full_year: 'short_month_name_with_full_year',
    short_month_name: 'short_month_name',
    month_name: 'month_name',
    numeric_day_with_short_month: 'numeric_day_with_short_month',
    numeric_day_with_month_name: 'numeric_day_with_month_name',
    weekday_short: 'weekday_short',
    ISO_format: 'ISO_format'
}

const getDefaultCulture = () => {
    return Vue.formatting.culture.replace('_', '-')
}

// String
String.prototype.interpolate = function (o) {
    return this.replace(/__(.*)__/g, function (a, b) {
        let r;
        r = o[b];
        if (typeof r === "string" || typeof r === "number") {
            return r;
        } else {
            return a;
        }
    });
};

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != "undefined" ? args[number] : match;
        });
    };
}

if (!String.str_equal) {
    String.str_equal = function (a, b, caseInsensitive = false) {
        if (caseInsensitive) {
            if (a == null) return b == null;
            if (b == null) return false;
            return a.toLowerCase() === b.toLowerCase();
        } else {
            return a === b;
        }
    };
}

export const nl2br = function (str) {
    if (!str) return "";
    return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
};

export const maxLength = function (s, max_len) {
    if (s === undefined) return "";
    if (s.length <= max_len) return s;
    return s.substr(0, max_len - 2) + "...";
};

export const formatName = function (obj) {
    if (!obj) return "";
    if (obj.name && obj.surname) return "{0} {1}".format(obj.name, obj.surname);
    if (obj.name) return obj.name;
    if (obj.surname) return obj.surname;
    return "";
};

export const formatInitials = function (item) {
    const n1 = item.name ? item.name.trim() : "";
    const n2 = item.surname ? item.surname.trim() : "";
    if (n1 && n2) return (n1.charAt(0) + n2.charAt(0)).toUpperCase();
    if (n1) return n1[0].toUpperCase();
    if (n2) return n2[0].toUpperCase();
    return "-";
};

export const capitalize = function (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatOverdue = function (seconds, short = false) {
    seconds = Number(seconds);
    if (seconds > 0) {
        const full_day = 86400
        const full_days = Math.trunc(seconds / full_day)
        if (seconds < full_day) return $t("Overdue");
        if (full_days === 1) return short ? $t("1 day") : $t("1 day overdue");
        return (short ? $t("{0} days") : $t("{0} days overdue")).format(full_days);
    }
}

export const friendlyJoin = function (arr, sep, sep_and) {
    switch (arr.length) {
        case 0:
            return "";
        case 1:
            return arr[0];
        case 2:
            return arr[0] + sep_and + arr[1];
    }
    return arr.concat(arr.splice(-2, 2).join(sep_and)).join(sep);
};

// Array
if (!Array.unique) {
    Array.unique = function (arr, caseInsensitive = false) {
        let ret = [];
        if (caseInsensitive) {
            let added_list = [];
            for (let i = 0; i < arr.length; i++) {
                let key = arr[i] == null ? arr[i] : arr[i].toLowerCase();
                if (added_list.indexOf(key) === -1) {
                    added_list.push(key);
                    ret.push(arr[i]);
                }
            }
        } else {
            for (let i = 0; i < arr.length; i++) {
                if (ret.indexOf(arr[i]) === -1) {
                    ret.push(arr[i]);
                }
            }
        }
        return ret;
    };
}

if (!Array.sort_by) {
    Array.sort_by = (arr, prop) => {
        arr.sort((a, b) => {
            if (a[prop] < b[prop]) return -1;
            if (a[prop] > b[prop]) return 1;
            return 0;
        });
        return arr;
    };
}

if (!Array.equalValues) {
    Array.equalValues = function (arr1, arr2) {
        if (!arr1) return !arr2;
        if (!arr2) return false;
        if (arr1.length !== arr2.length) return false;
        for (let i of arr1) {
            if (arr2.indexOf(i) === -1) return false;
        }
        for (let i of arr2) {
            if (arr1.indexOf(i) === -1) return false;
        }
        return true;
    };
}

// Booleans
export const formatBool = function (value, show_false = true) {
    return value ? $t("Yes") : show_false ? $t("No") : "";
};

// Numbers
Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

export const formatNumberCustom = function (number, min_decimals, max_decimals, decimal_symbol, thousands_symbol) {
    if (typeof number == "string") number = parseFloat(number);
    return number
        .toLocaleString("en-GB", {
            minimumFractionDigits: min_decimals,
            maximumFractionDigits: max_decimals
        })
        .replace(/\.|,/gi, function (x) {
            return x == "." ? decimal_symbol : thousands_symbol;
        });
};

export const cleanNumberCustom = function (str, decimal_symbol, thousands_symbol) {
    let a = str
        .replaceAll(thousands_symbol, "")
        .replaceAll(" ", "")
        .replaceAll(decimal_symbol, ".")

    return a
};

export const cleanNumber = function (value, decimal_symbol = null, thousands_symbol = null) {
    let _decimal_symbol = decimal_symbol == null ? Vue.formatting.decimal_symbol : decimal_symbol
    let _thousands_symbol = thousands_symbol == null ? Vue.formatting.thousands_symbol : thousands_symbol

    let str = "" + value

    return cleanNumberCustom(
        str,
        _decimal_symbol,
        _thousands_symbol
    );
};

export const formatNumber = function (number, min_decimals = null, max_decimals = null) {
    if (min_decimals === null) min_decimals = 0;
    if (max_decimals === null) max_decimals = 4;
    if (number == null) return "";
    if (typeof number == "string") number = parseFloat(number);
    return formatNumberCustom(
        number,
        min_decimals,
        max_decimals,
        Vue.formatting.decimal_symbol,
        Vue.formatting.thousands_symbol
    );
};

export const formatPercent = function (number) {
    if (number == null || number === "") return "";
    return "{0}%".format(formatNumber(number * 100));
};

// Money
export const formatMoneyCustom = function (
    number,
    currency,
    show_decimals
) {
    return Intl.NumberFormat(getDefaultCulture(), {style: 'currency', currency: currency, maximumFractionDigits: show_decimals ? show_decimals : 0}).format(number)
};

export const formatMoneyNoDecimals = function (number, currency) {
    return formatMoneyCustom(
        number,
        currency,
        0
    );
};

export const formatMoneyNumber = function (value) {
    if (value === null) {
        return "";
    }
    if (typeof value === "string") {
        return formatNumber(parseFloat(value), 2, 2);
    }
    return formatNumber(value, 2, 2);
};

export const formatMoney = function (number, currency) {
    return formatMoneyCustom(
        number,
        currency,
        2
    );
};

// Date, DateTime and Time
export const format_date_re = /(dddd|dd|d|hh|h|HH|H|mm|m|MMMM|MMM|MM|M|ss|s|tt|yyyy|yy|zzz)/g;
export const formatDateCustom = function (d, format) {
    if (format === CustomFormats.ISO_format) return d.toISOString()

    const locale = getDefaultCulture()

    // Estonian short month is still displayed as full
    // ugly hack but I don't see another way
    if (locale === 'et-EE' && format === CustomFormats.short_month_name) {
        let ee_months = [
            "Jaan",
            "Veebr",
            "Märts",
            "Apr",
            "Mai",
            "Juuni",
            "Juuli",
            "Aug",
            "Sept",
            "Okt",
            "Nov",
            "Dets"
        ];
        return ee_months[d.getMonth()];
    }

    const options = (() => {
        switch (format) {
            case CustomFormats.numeric_month_with_short_year:
                return {month: '2-digit', year: '2-digit'}
            case CustomFormats.month_name_with_full_year:
                return {month: 'long', year: 'numeric'}
            case CustomFormats.short_month_name_with_full_year:
                return {month: 'short', year: 'numeric'}
            case CustomFormats.short_month_name:
                return {month: 'short'}
            case CustomFormats.month_name:
                return {month: 'long'}
            case CustomFormats.numeric_day_with_short_month:
                return {day: 'numeric', month: 'short'}
            case CustomFormats.numeric_day_with_month_name:
                return {day: 'numeric', month: 'long'}
            case CustomFormats.weekday_short:
                return {weekday: 'short'}
            default:
                throw Error(format + ' NOT SUPPORTED YET')
        }
    })()
    return new Intl.DateTimeFormat(locale, options).format(d)
};

export const formatDate = function (d) {
    if (!d) return "";
    const dateToFormat = typeof d == "string" ? parseSysDate(d) : d
    const locale = getDefaultCulture()
    return new Intl.DateTimeFormat(locale, {day: '2-digit', month: '2-digit', year: 'numeric'}).format(dateToFormat)
};

export const formatDateTime = function (dt) {
    if (!dt) return "";
    const dateToFormat = typeof dt == "string" ? parseSysDateTime(dt) : dt
    const locale = getDefaultCulture()
    return new Intl.DateTimeFormat(locale, {dateStyle: 'short', timeStyle: 'short'}).format(dateToFormat)
};

export const formatDateTimeOrTime = (dt) => {
    const currentDate = new Date()
    const dateToFormat = typeof dt == "string" ? parseSysDateTime(dt) : new Date(dt.getTime())
    currentDate.setSeconds(0)
    currentDate.setMilliseconds(0)
    dateToFormat.setSeconds(0)
    dateToFormat.setMilliseconds(0)

    if (dateToFormat.toDateString() === currentDate.toDateString()) {
        let timeAgoText = ''

        const time = formatTime(dateToFormat)

        if (currentDate > dateToFormat) {
            const diff = Math.abs(currentDate - dateToFormat);

            const minutes = Math.floor((diff / 1000) / 60);
            const hours = Math.floor((diff / 1000) / (60 * 60));

            if (minutes < 60) {
                if (minutes === 1) {
                    timeAgoText = ' (' + $t('{0} minute ago').format(minutes) + ')'
                } else {
                    timeAgoText = ' (' + $t('{0} minutes ago').format(minutes) + ')'
                }
            } else {
                if (hours === 1) {
                    timeAgoText = ' (' + $t('{0} hour ago').format(hours) + ')'
                } else {
                    timeAgoText = ' (' + $t('{0} hours ago').format(hours) + ')'
                }
            }
        }

        return time + timeAgoText
    }

    return formatDateShort(dateToFormat)
}

export const formatDateShort = function (d) {
    if (!d) return "";
    let d_obj = typeof d == "string" ? parseSysDate(d) : d;
    const locale = getDefaultCulture()
    const options = {day: '2-digit', month: '2-digit', year: d_obj.getFullYear() === new Date().getFullYear() ? undefined : 'numeric'}
    return Intl.DateTimeFormat(locale, options).format(d_obj)
};

export const formatDateFriendlyNoYear = function (d, shortMonth = true) {
    if (!d) return "";
    const dateToFormat = typeof d == "string" ? parseSysDate(d) : d
    const locale = getDefaultCulture()
    return new Intl.DateTimeFormat(locale, {month: shortMonth ? 'short' : 'long', day: 'numeric'}).format(dateToFormat)
};

export const formatTime = function (dt) {
    if (!dt) return "";
    const dateToFormat = typeof dt == "string" ? dt.length <= 8 ? parseSysTime(dt) : parseSysDateTime(dt) : dt
    const locale = getDefaultCulture()
    return new Intl.DateTimeFormat(locale, {timeStyle: 'short'}).format(dateToFormat)
};

export const formatTimeFromStr = function (s) {
    if (s == null) return "";
    let arr = s.split(":");
    if (arr.length < 2) return "";
    let d = new Date();
    d.setHours(parseInt(arr[0]), parseInt(arr[1]), arr.length > 2 ? parseInt(arr[2]) : 0, 0);
    return formatTime(d);
};

export const weekdayNames = () => {
    return [
        $t("Sunday"),
        $t("Monday"),
        $t("Tuesday"),
        $t("Wednesday"),
        $t("Thursday"),
        $t("Friday"),
        $t("Saturday")
    ];
}
export const formatWeekday = d => weekdayNames()[d.getDay()];

export const weekdayNamesShort = () => {
    return [$t("Sun"), $t("Mon"), $t("Tue"), $t("Wed"), $t("Thu"), $t("Fri"), $t("Sat")];
}
export const formatWeekdayShort = d => weekdayNamesShort()[d.getDay()];

export const monthNames = () => {
    return [
        $t("January"),
        $t("February"),
        $t("March"),
        $t("April"),
        $t("May"),
        $t("June"),
        $t("July"),
        $t("August"),
        $t("September"),
        $t("October"),
        $t("November"),
        $t("December")
    ];
}
export const formatMonthName = d => monthNames()[d.getMonth()];

export const monthNamesShort = [
    $t("Jan"),
    $t("Feb"),
    $t("Mar"),
    $t("Apr"),
    $t("May"),
    $t("Jun"),
    $t("Jul"),
    $t("Aug"),
    $t("Sep"),
    $t("Oct"),
    $t("Nov"),
    $t("Dec")
];
export const formatMonthShort = d => monthNamesShort[d.getMonth()];

export const formatSysTime = function (d) {
    return "{0}:{1}:{2}".format(
        ("0" + d.getHours()).slice(-2),
        ("0" + d.getMinutes()).slice(-2),
        ("0" + d.getSeconds()).slice(-2)
    );
};

export const formatSysDate = function (d) {
    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
};

export const formatSysDateTime = function (d) {
    return formatSysDate(d) + " " + formatSysTime(d);
};

export const parseSysDate = function (d_str) {
    let arr = d_str.substr(0, 10).split("-");
    return new Date(parseInt(arr[0], 10), parseInt(arr[1], 10) - 1, parseInt(arr[2], 10));
};

export const parseSysTime = function (t_str) {
    let arr = t_str.split(":");
    let d = new Date();
    d.setHours(parseInt(arr[0]), parseInt(arr[1]), arr.length > 2 ? parseInt(arr[2]) : 0, 0);
    return d;
};

export const parseSysDateTime = function (d_str) {
    let m = d_str.split(/[: -]/);
    return new Date(parseInt(m[0]), parseInt(m[1]) - 1, parseInt(m[2]), parseInt(m[3]), parseInt(m[4]), parseInt(m[5]));
};

export const formatLastModified = function (dt) {
    const now = new Date();

    // Today
    if (calcDateEquals(now, dt, "day")) {
        return "{1}, {0}".format(formatTime(dt), $t("Today"));
    }

    let dt_f = formatDateTime(dt);

    // Yesterday
    const now_m1 = now.calcAddDays(-1);
    if (calcDateEquals(now_m1, dt, "day")) {
        dt_f = "{1}, {0}".format(formatTime(dt), $t("Yesterday"));

        // This week
    } else if (dt - now.calcWeekStart() > 0) {
        dt_f = "{1}, {0}".format(formatTime(dt), formatWeekday(dt));

        // This year
    } else if (dt.getYear() === now.getYear()) {
        dt_f = formatDateTime(dt);
    }

    return dt_f;
};

export const formatLastModifiedHtml = dt_str => {
    const now = new Date();
    const dt = parseSysDateTime(dt_str);

    // relative time
    if (calcDateEquals(now, dt, "day")) {
        return '<span title="{0}" sys-date="{1}" class="relative-time">{2}</span>'.format(
            dt_str,
            formatDateCustom(dt, CustomFormats.ISO_format),
            "{1}, {0}".format(formatTime(dt), $t("Today"))
        );
    } else {
        return '<span title="' + dt_str + '">' + formatLastModified(dt) + "</span>";
    }
};

export const calcDateDiff = {
    inDays: function (d1, d2) {
        let t2 = new Date(d2.toDateString()).getTime();
        let t1 = new Date(d1.toDateString()).getTime();

        return parseInt((t2 - t1) / (24 * 3600 * 1000));
    },

    inWeeks: function (d1, d2) {
        let t2 = d2.getTime();
        let t1 = d1.getTime();

        return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7));
    },

    inMonths: function (d1, d2) {
        let d1Y = d1.getFullYear();
        let d2Y = d2.getFullYear();
        let d1M = d1.getMonth();
        let d2M = d2.getMonth();

        return d2M + 12 * d2Y - (d1M + 12 * d1Y);
    },

    inYears: function (d1, d2) {
        return d2.getFullYear() - d1.getFullYear();
    }
};

export const calcDateEquals = function (d1, d2, unit) {
    switch (unit) {
        case "day": {
            return calcDateDiff.inDays(d1, d2) === 0;
        }
        case "date": {
            return calcDateDiff.inDays(d1, d2) === 0;
        }
        case "week": {
            return calcDateDiff.inWeeks(d1, d2) === 0;
        }
        case "month": {
            return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
        }
        case "year": {
            return d1.getFullYear() === d2.getFullYear();
        }
    }
    return d1 === d2;
};

export const calcDaysInMonth = function (year, month) {
    return new Date(year, month, 0).getDate();
};

export const parseTime = function (data) {
    if (!data) return null;

    // "1", "2", ... , "23"
    let re = /^(\d{1,2})$/;
    let m = data.match(re);
    if (m != null) {
        let h = parseInt(m[1]);
        if (h >= 0 && h <= 23) return "{0}:00:00".format(("0" + h).slice(-2));
        return null;
    }

    // "000" ... "2359"
    re = /^(\d{1,2})(\d{2})$/;
    m = data.match(re);
    if (m != null) {
        let h = parseInt(m[1]);
        let mn = parseInt(m[2]);
        if (h >= 0 && h <= 23 && mn >= 0 && mn <= 59)
            return "{0}:{1}:00".format(("0" + h).slice(-2), ("0" + mn).slice(-2));
        return null;
    }

    // "0:00" ... "23:59"; "12:00 am" ... "12:59 pm"
    re = /^(([0-1]{0,1}[\d]{1}|2[0-3]{1})[:|.]([0-5]{1}[\d]{1}))$|^((0{0,1}[\d]{1}|1[0-2]{1})[:|.]([0-5]{1}[\d]{1})[ ]{0,4}([AaPp]{1}[Mm]{1}))$/;
    m = data.match(re);

    if (m == null) return null;

    if (m[2] != null) {
        return "{0}:{1}:00".format(("0" + m[2]).slice(-2), ("0" + m[3]).slice(-2));
    } else if (m[5] != null) {
        let h = parseInt(m[5]);
        h = (h === 12 ? 0 : h) + (m[7].toLowerCase() === "pm" ? 12 : 0);
        return "{0}:{1}:00".format(("0" + h).slice(-2), ("0" + m[6]).slice(-2));
    }

    return null;
};

function getDateFormatPattern(locale) {
    const getPatternForPart = (part) => {
        switch (part.type) {
            case 'day':
                return 'd'.repeat(part.value.length);
            case 'month':
                return 'M'.repeat(part.value.length);
            case 'year':
                return 'y'.repeat(part.value.length);
            case 'literal':
                return part.value;
        }
    };

    return new Intl.DateTimeFormat(locale, {day: '2-digit', month: '2-digit', year: 'numeric'}).formatToParts(new Date('2022-01-01'))
        .map(getPatternForPart)
        .join('');
};

export const parseDate = function (data) {
    let dateFormat = getDateFormatPattern(getDefaultCulture())
    // This is currently specifically for bulgarian, however there might be more
    dateFormat = dateFormat.replaceAll(' ', ' ')

    const date = parse(data, dateFormat, new Date())
    if (isNaN(date)) {
        return null
    }

    return date
}

export const formatTimeDuration = function (sec, empty = "", adaptive = false, hideSecondsIfZero = false) {
    if (sec == null) return empty;

    // Convert it to a positive number and append minus symbol at the end
    let isNegative = sec < 0
    if (isNegative) {
        sec *= -1
    }

    let s = sec % 60;
    let m = (sec - s) % 3600;
    let h = (sec - m - s) / 3600;

    let output = ""

    if (hideSecondsIfZero && s === 0) {
        output = "{0}:{1}".format(h, ("0" + Math.floor(m / 60)).slice(-2));
    } else if (adaptive && h < 1) {
        output = "{0}:{1}".format(("0" + Math.floor(m / 60)).slice(-2), ("0" + s).slice(-2));
    } else {
        output = "{0}:{1}:{2}".format(h, ("0" + Math.floor(m / 60)).slice(-2), ("0" + s).slice(-2));
    }

    if (isNegative) {
        output = "- " + output
    }

    return output
};

export const formatGmtTimeDuration = function (sec, empty = "") {
    if (sec == null) return empty;

    // Convert it to a positive number and append minus symbol at the end
    let isNegative = sec < 0
    if (isNegative) {
        sec *= -1
    }

    let s = sec % 60;
    let m = (sec - s) % 3600;

    let output = "{0}:{1}".format(("0" + Math.floor(m / 60)).slice(-2), ("0" + s).slice(-2));

    if (isNegative) {
        output = "-" + output
    } else {
        output = "+" + output
    }

    return output
};

export const parseSysEndDate = function (date) {
    let dateUntilToSaveDate = parseSysDateTime(date)
    if (isNaN(dateUntilToSaveDate)) {
        dateUntilToSaveDate = parseSysDate(date)
    }

    dateUntilToSaveDate.setSeconds(dateUntilToSaveDate.getSeconds() - 1)
    dateUntilToSaveDate = formatSysDate(dateUntilToSaveDate)

    return dateUntilToSaveDate
};

export const formatDatesFromUntil = function (dateFrom, dateUntil, negateEndDate = true) {
    const timezoneDifference = dateFrom.getTimezoneOffset() - dateUntil.getTimezoneOffset()
    const timeDifference = Math.abs(dateUntil - dateFrom + (timezoneDifference * 60 * 1000))

    if (timeDifference === (60 * 60 * 24 * 1000)) {
        return formatDate(dateFrom)
    } else if (timeDifference < (60 * 60 * 24 * 1000)) {
        return formatDate(dateFrom) + ' / ' + formatTime(dateFrom) + ' - ' + formatTime(dateUntil)
    } else {
        let dateUntilCopy = new Date(dateUntil)
        if (negateEndDate) {
            dateUntilCopy.setSeconds(dateUntilCopy.getSeconds() - 1)
        }

        return formatDate(dateFrom) + ' - ' + formatDate(dateUntilCopy)
    }
};

export const formatDaysOrTimeFromDates = function (dateFrom, dateUntil) {
    let duration = Math.abs(dateUntil - dateFrom)

    if (duration === (60 * 60 * 24 * 1000)) {
        return '1 ' + $t('Day')
    } else if (duration < (60 * 60 * 24 * 1000)) {
        return formatTimeDuration(duration / 1000)
    } else {
        let days = Math.round((dateUntil - dateFrom) / (1000 * 60 * 60 * 24));

        return days + ' ' + $t('Days')
    }
};

export const formatDaysFromDuration = function (duration, appendText) {
    let secondsInDay = 60 * 60 * 24
    let days = Math.round(duration / secondsInDay, 1)
    let appendTextValue = $t('days')

    if (days === 1.0) {
        appendTextValue = $t('day')
    }

    let output = String(days)
    if (appendText) {
        output += " " + appendTextValue
    }

    return output
};

export const formatFlextimeDuration = function (sec, empty = "+ 00:00:00") {
    if (sec == null) return empty;

    // Convert it to a positive number and append minus symbol at the end
    let isNegative = sec < 0
    if (isNegative) {
        sec *= -1
    }

    let s = sec % 60;
    let m = (sec - s) % 3600;
    let h = (sec - m - s) / 3600;

    let output = "{0}:{1}:{2}".format(String(h).padStart(2, '0'), ("0" + Math.floor(m / 60)).slice(-2), ("0" + s).slice(-2));

    if (isNegative) {
        output = "- " + output
    } else {
        output = "+ " + output
    }

    return output
};

export const parseTimeDuration = function (t_str, assumeHours = false) {
    let inp = t_str.trim();

    // H:mm:ss
    // H:mm
    // mm

    let patt1 = /^(\d+)(:(\d{2})(:(\d{2}))?)?$/gi;
    let m1 = patt1.exec(inp);

    if (m1 != null) {
        // if its just a number, assume its meant as minutes
        if (!m1[2] && !m1[4]) {
            if (assumeHours) {
                return parseInt(m1[1]) * 60 * 60;
            } else {
                return parseInt(m1[1]) * 60;
            }
        }
        let time = parseInt(m1[1]) * 60 * 60;
        if (m1[3]) time += parseInt(m1[3]) * 60;
        if (m1[5]) time += parseInt(m1[5]);
        return time;
    }

    // H.H h|hour|hours
    // m.m min|mn|minute|minutes|m
    // H h|hour|hours
    // m min|mn|minute|minutes|m
    // H.H
    // H

    let patt2 = /^(\d+([,.]{1}\d+)?)[ ]*(h|min|mn|minutes|minute|m|hour|hours)?$/gi;
    let m2 = patt2.exec(inp);

    if (m2 != null) {
        let nr = parseFloat(m2[1].replace(",", "."));
        let unit = "h";

        if (m2[3]) {
            m2[3] = m2[3].toLowerCase();
            if (m2[3] === "h" || m2[3] === "hour" || m2[3] === "hours") unit = "h";
            else if (m2[3] === "min" || m2[3] === "mn" || m2[3] === "minute" || m2[3] === "minutes" || m2[3] === "m")
                unit = "min";
            else return null;
        }

        return Math.round(nr * (unit === "h" ? 60 * 60 : 60));
    }

    // H h|hour|hours m min|mn|minute|minutes|m

    let patt3 = /^[ ]*(\d+)[ ]*(h|hour|hours)[ ]*(\d+)[ ]*((min|mn|minutes|minute|m)[ ]*)?$/gi;
    let m3 = patt3.exec(inp);
    if (m3 != null) {
        let h = parseInt(m3[1]);
        let min = parseInt(m3[3]);
        return h * 60 * 60 + min * 60;
    }

    return null;
};

Date.prototype.formatDate = function () {
    return formatDate(this);
};
Date.prototype.formatDateTime = function () {
    return formatDateTime(this);
};
Date.prototype.formatSysDate = function () {
    return formatSysDate(this);
};
Date.prototype.formatSysTime = function () {
    return formatSysTime(this);
};
Date.prototype.formatSysDateTime = function () {
    return formatSysDateTime(this);
};
Date.prototype.calcDaysInMonth = function () {
    return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
};
Date.prototype.calcWeekStart = function () {
    let new_d = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    let week_day = new_d.getDay();

    if (Vue.formatting.first_week_day === 7) {
        week_day += 1
    }

    let diff = this.getDate() - week_day + (week_day === 0 ? -6 : 1);
    new_d.setDate(diff);
    return new_d;
};
Date.prototype.thisMonth = function () {
    let now = new Date();
    let day = Math.min(this.getDate(), now.calcDaysInMonth());
    this.setDate(1);
    this.setFullYear(now.getFullYear());
    this.setMonth(now.getMonth());
    this.setDate(day);
    return this;
};
Date.prototype.getWeekNumber = function () {
    var date = new Date(this.getTime());

    date.setHours(0, 0, 0, 0);
    /*
     * Thursday in current week decides the year.
     */

    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    /*
     * January 4 is always in week 1.
     */

    var week1 = new Date(date.getFullYear(), 0, 4);
    /*
     * Adjust to Thursday in week 1 and count number of weeks from date to week1.
     */

    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
};
Date.prototype.calcWeekEnd = function () {
    let new_d = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    let week_day = new_d.getDay();
    let new_week_day = Vue.formatting.first_week_day === 7 ? (week_day + 1) : week_day
    let start_shift = Vue.formatting.first_week_day === 7 ? 6 : 0

    let diff = this.getDate() + (week_day === 0 ? start_shift : 7 - new_week_day);
    new_d.setDate(diff);
    return new_d;
};
Date.prototype.calcMonthStart = function () {
    return new Date(this.getFullYear(), this.getMonth(), 1);
};
Date.prototype.calcMonthEnd = function () {
    let max_d = calcDaysInMonth(this.getFullYear(), this.getMonth() + 1);
    return new Date(this.getFullYear(), this.getMonth(), max_d);
};
Date.prototype.calcDateAdd = function (add, unit) {
    switch (unit) {
        case "day": {
            return this.calcAddDays(add);
        }
        case "week": {
            return this.calcAddDays(add * 7);
        }
    }
    return this;
};
Date.prototype.calcNextMonth = function () {
    let y = this.getFullYear();
    let m = this.getMonth() + 1;
    let d = this.getDate();
    if (m > 11) {
        m = 0;
        y = y + 1;
    }
    let max_d = calcDaysInMonth(y, m + 1);
    if (d > max_d) d = max_d;
    return new Date(y, m, d, this.getHours(), this.getMinutes(), this.getSeconds());
};
Date.prototype.calcAddMonths = function (months) {
    let day = this.getDate();
    let d = new Date(this.getFullYear(), this.getMonth() + months, 1);
    d.setDate(Math.min(day, d.calcDaysInMonth()));
    return d;
};
Date.prototype.calcAddYears = function (years) {
    let day = this.getDate();
    let d = new Date(this.getFullYear() + years, this.getMonth(), 1);
    d.setDate(Math.min(day, d.calcDaysInMonth()));
    return d;
};
Date.prototype.calcAddDays = function (days) {
    let new_d = new Date(this);
    new_d.setDate(new_d.getDate() + days);
    return new_d;
};

// Recurrence formatting
Vue.format_date_part = function (model, prefix, add_type_sentence, date = null) {
    let date_part = null;

    if (
        prefix === "due_" &&
        ["weekly", "monthly", "quarterly", "yearly"].indexOf(model.type) >= 0 &&
        model.due_calc_type &&
        ["calendar_days", "mon_fri_days", "work_days"].indexOf(model.due_calc_type) >= 0
    ) {
        let plus_f = model.due_calc_type === "calendar_days" ? $t("+{0} d") : $t("+{0} wd");
        return plus_f.format(model.due_count_days ? model.due_count_days : 0);
    }

    let interval = model.interval ? model.interval : 1;

    switch (model.type) {
        case "date":
            if (!date) {
                date = model[prefix + "date"] == null ? null : parseSysDate(model[prefix + "date"]);
            }
            date_part = formatDate(date);
            break;

        case "weekly": {
            let part_format = add_type_sentence
                ? interval === 1
                    ? $t("Weekly {0}")
                    : $t("Every {0}. week {1}").format(interval, "{0}")
                : $t("{0}");
            date_part = part_format.format(Vue.get_weekdays_string(model));
            break;
        }

        case "monthly": {
            let day_of_month = model[prefix + "day_of_month"];
            if (day_of_month) {
                let part_format = add_type_sentence
                    ? interval === 1
                        ? $t("Monthly {0}. d")
                        : $t("Every {0}. month {1}. d").format(interval, "{0}")
                    : $t("{0}. d");
                date_part = part_format.format(day_of_month);
            }
            break;
        }

        case "quarterly": {
            let day_of_month = model[prefix + "day_of_month"];
            let month_of_period = model[prefix + "month_of_period"];
            if (day_of_month && month_of_period) {
                let part_format = add_type_sentence
                    ? interval === 1
                        ? $t("Quarterly {0}. month {1}. d")
                        : $t("Every {0}. quarter {1}. month {2}. d").format(interval, "{0}", "{1}")
                    : $t("{0}. month {1}. d");
                date_part = part_format.format(month_of_period, day_of_month);
            }
            break;
        }

        case "yearly": {
            let day_of_month = model[prefix + "day_of_month"];
            let month_of_period = model[prefix + "month_of_period"];
            if (day_of_month && month_of_period) {
                let yd = new Date(2016, month_of_period - 1, 1);
                const daysInMonth = yd.calcDaysInMonth()
                const date = day_of_month < daysInMonth ? day_of_month : daysInMonth
                yd.setDate(date)

                let part_format = add_type_sentence
                    ? interval === 1
                        ? $t("Yearly {0}")
                        : $t("Every {0}. year {1}").format(interval, "{0}")
                    : $t("{0}");
                date_part = part_format.format(formatDateCustom(yd, CustomFormats.numeric_day_with_short_month));
            }
            break;
        }
    }

    return date_part;
};

Vue.format_datetime_part = function (model, prefix, add_recurrence_type_prefix) {
    let date_part = Vue.format_date_part(model, prefix, add_recurrence_type_prefix);

    let time_part = null;
    if (model[prefix + "date_only"] === undefined || model[prefix + "date_only"]) {
        time_part = null;
    } else {
        if (model[prefix + "time"]) {
            let time_arr = model[prefix + "time"].split(":");
            let date = new Date();
            date.setHours(parseInt(time_arr[0]), parseInt(time_arr[1]), 0, 0);
            time_part = formatTime(date);
        }
    }

    if (date_part == null) return {date: null, time: null, full: null};
    if (time_part == null) return {date: date_part, time: null, full: date_part};
    return {date: date_part, time: time_part, full: Vue.date_part_output(date_part, time_part)};
};

Vue.get_weekdays_string = function (model) {
    if (!model.weekdays) return "";

    let weekdays = model.weekdays;
    if (weekdays.length === 0) return "";

    let week_days_short = [$t("Mo"), $t("Tu"), $t("We"), $t("Th"), $t("Fr"), $t("Sa"), $t("Su")];
    let ret = "";
    let sep = "";

    for (let i = 0; i < weekdays.length; i++) {
        ret += sep + week_days_short[weekdays[i] - 1];
        sep = i >= weekdays.length - 2 ? " {0} ".format($t("and")) : ", ";
    }

    return ret;
};

Vue.date_part_output = function (date_part, time_part, html = false) {
    if (date_part == null) return "";
    if (time_part == null) return date_part;
    else return (html ? "{1} {0}" : "{0} @{1}").format(date_part, time_part);
};

Vue.compose_datetime_parts = function (date_part, due_date_part) {
    if (date_part.date == null) return "";
    if (due_date_part == null || due_date_part.date == null) return date_part.full;
    if (date_part.full === due_date_part.full) return date_part.full;
    if (date_part.date === due_date_part.date) {
        if (due_date_part.time == null) return date_part.full;
        return "{0} / @{1}".format(date_part.full, due_date_part.time);
    }
    return "{0} / {1}".format(date_part.full, due_date_part.full);
};

Vue.compose_datetime_parts_html = function (date_part, due_date_part) {
    if (date_part.date == null) return "";
    if (due_date_part == null || due_date_part.date == null)
        return '<span class="single-date">{0}</span>'.format(date_part.full);
    if (date_part.full === due_date_part.full) return '<span class="single-date">{0}</span>'.format(date_part.full);
    if (date_part.date === due_date_part.date) {
        if (due_date_part.time == null) return '<span class="single-date">{0}</span>'.format(date_part.full);
        return '<span class="start-date">{0}</span> / <span class="due-date">{1}</span>'.format(
            date_part.full,
            due_date_part.time
        );
    }
    return '<span class="start-date">{0}</span> / <span class="due-date">{1}</span>'.format(
        date_part.full,
        due_date_part.full
    );
};

Vue.format_datetime_part_once = function (model, prefix, html = false) {
    let date_part =
        model[prefix + "date"] == null
            ? null
            : html
                ? formatDateShort(model[prefix + "date"])
                : formatDate(model[prefix + "date"]);

    let time_part = null;
    if (model[prefix + "date_only"] === undefined || model[prefix + "date_only"]) {
        time_part = null;
    } else {
        if (model[prefix + "date"].length >= 16) {
            let time_arr = model[prefix + "date"].substr(11).split(":");
            let date = new Date();
            date.setHours(parseInt(time_arr[0]), parseInt(time_arr[1]), 0, 0);
            time_part = formatTime(date);
        }
    }

    if (date_part == null) return {date: null, time: null, full: null};

    let date_part_output = html ? '<span class="date-part">{0}</span>'.format(date_part) : date_part;
    if (time_part == null)
        return {
            date: date_part_output,
            time: null,
            full: date_part_output
        };

    let time_part_output = html ? '<span class="time-part">@{0}</span>'.format(time_part) : time_part;
    return {
        date: date_part_output,
        time: time_part_output,
        full: Vue.date_part_output(date_part_output, time_part_output, html)
    };
};

export const formatRecurrenceOnce = function (task, html = false) {
    if (task == null) return "";

    let date_part = Vue.format_datetime_part_once(task, "", html);
    let due_date_part = task.has_due_date ? Vue.format_datetime_part_once(task, "due_", html) : null;

    return html
        ? Vue.compose_datetime_parts_html(date_part, due_date_part)
        : Vue.compose_datetime_parts(date_part, due_date_part);
};

export const formatRecurrenceWorkflow = (val, custom_fields) => {
    if (val == null) return "";

    if (!val.date_field || val.count_days === undefined)
        return "";

    let d = val.count_days % 7;
    let w = (val.count_days - d) / 7;
    let ret = [];

    if (w > 0)
        ret.push($t("{0}w").format(formatNumber(w)));
    if (d > 0)
        ret.push($t("{0}d").format(formatNumber(d)));
    if (ret.length === 0)
        ret.push($t("{0}d").format(formatNumber(d)));
    ret.push(val.date_dir === "before" ? $t("before") : $t("after"));
    ret.push($t('Project'));

    let fld = custom_fields.find(x => x.name === val.date_field);
    ret.push(fld == null ? val.date_field : fld.title);

    if (val.has_due_date) {
        ret.push("/");
        ret.push($t("{0}d").format(formatNumber(val.due_count_days)));
    }
    return ret.join(" ");
};

export const formatRecurrence = function (val, add_recurrence_type_prefix = true) {
    if (val == null) return "";

    let date_part = Vue.format_datetime_part(val, "", add_recurrence_type_prefix);
    let due_date_part = val.has_due_date ? Vue.format_datetime_part(val, "due_", false) : null;

    return Vue.compose_datetime_parts(date_part, due_date_part);
};

export const formatPeriodLabel = function (period_label) {
    let re = new RegExp("^(\\d{4})(-(\\d{2})(-(\\d{2}))?|-Q([1-4]{1}))?$");
    let m = re.exec(period_label);

    if (!m) {
        return period_label;
    }

    if (m[3]) {
        if (m[5]) {
            // yearly
            const df = parseSysDate(period_label);
            let du = parseSysDate(period_label);
            du.setFullYear(du.getFullYear() + 1);
            du = du.calcAddDays(-1);

            return "{0} - {1}".format(formatDate(df), formatDate(du));
        } else {
            // monthly
            let d = new Date(parseInt(m[1]), parseInt(m[3]) - 1, 1);
            let str = formatDateCustom(d, CustomFormats.short_month_name_with_full_year);
            str = str.charAt(0).toUpperCase() + str.slice(1);
            return str;
        }
    } else if (m[6]) {
        // quarterly
        return "{2} {1} {0}".format(m[1], m[6], $t("Quarter"));
    }

    return period_label;
};

// Files
Vue.default_file_icon = {"color": "primary", "icon": "mdi-file"};

Vue.file_icons = {
    "txt": {"color": "blue", "icon": "mdi-file-document"},
    "zip": {"color": "lime", "icon": "mdi-zip-box"},
    "xml": {"color": "cyan", "icon": "mdi-file-xml"},
    "htm": {"color": "blue", "icon": "mdi-file-cloud"},
    "html": {"color": "blue", "icon": "mdi-file-cloud"},

    "pdf": {"color": "red", "icon": "mdi-file-pdf"},
    "xls": {"color": "green", "icon": "mdi-file-excel"},
    "xlsx": {"color": "green", "icon": "mdi-file-excel"},
    "numbers": {"color": "green", "icon": "mdi-file-table"},
    "doc": {"color": "blue", "icon": "mdi-file-word"},
    "docx": {"color": "blue", "icon": "mdi-file-word"},
    "rtx": {"color": "blue", "icon": "mdi-file-word"},
    "csv": {"color": "green", "icon": "mdi-file-delimited"},
    "ppt": {"color": "red", "icon": "mdi-file-powerpoint"},
    "pptx": {"color": "red", "icon": "mdi-file-powerpoint"},

    "gif": {"color": "deep-orange", "icon": "mdi-file-image"},
    "png": {"color": "deep-orange", "icon": "mdi-file-image"},
    "jpg": {"color": "deep-orange", "icon": "mdi-file-image"},
    "jpeg": {"color": "deep-orange", "icon": "mdi-file-image"},
    "jpe": {"color": "deep-orange", "icon": "mdi-file-image"},
    "svg": {"color": "deep-orange", "icon": "mdi-file-image"},

    "wmv": {"color": "deep-orange", "icon": "mdi-file-video"},
    "flv": {"color": "deep-orange", "icon": "mdi-file-video"},
    "avi": {"color": "deep-orange", "icon": "mdi-file-video"},
    "mpg": {"color": "deep-orange", "icon": "mdi-file-video"},
    "mp4": {"color": "deep-orange", "icon": "mdi-file-video"},
    "mov": {"color": "deep-orange", "icon": "mdi-file-video"},

    "wav": {"color": "deep-orange", "icon": "mdi-file-music"},
    "mp3": {"color": "deep-orange", "icon": "mdi-file-music"},
    "ogg": {"color": "deep-orange", "icon": "mdi-file-music"}
};

export const getIconProp = function (file_name, prop) {
    let pos = file_name.lastIndexOf(".");
    if (pos < 0) return Vue.default_file_icon[prop];

    let ext = file_name.substr(pos + 1);
    if (Vue.file_icons[ext] === undefined) return Vue.default_file_icon[prop];

    return Vue.file_icons[ext][prop];
};

export const iconColor = function (file_name) {
    return getIconProp(file_name, "color");
};

export const iconName = function (file_name) {
    return getIconProp(file_name, "icon");
};

export const fileNameMaxLength = function (s, max_len) {
    if (s.length <= max_len) return s;

    var pos = s.lastIndexOf(".");
    if (pos === -1) return s.substr(0, max_len - 3) + "...";

    return s.substr(0, max_len - (s.length - pos) - 2) + "..." + s.substr(pos + 1);
};

export const fileColor = function (file_name, for_text = false) {
    let prefix = for_text ? "--text" : "";
    let pos = file_name.lastIndexOf(".");
    if (pos < 0) return Vue.default_file_icon.color + prefix;

    let ext = file_name.substr(pos + 1);
    if (Vue.file_icons[ext] === undefined) return Vue.default_file_icon.color + prefix;

    return Vue.file_icons[ext].color + prefix;
};

export const fileExtension = function (file_name) {
    let pos = file_name.lastIndexOf(".");
    return pos < 0 ? "-" : file_name.substr(pos + 1);
};

export const fileName = function (file_name) {
    let pos = file_name.lastIndexOf(".");
    return pos < 0 ? file_name : file_name.substr(0, pos);
};

// Form data helpers
Vue.clone_object = function (src) {
    if (src == null) return null;
    return JSON.parse(JSON.stringify(src));
};

Vue.clean_and_clone_object = function (src) {
    let target = {};
    for (let prop in src) {
        if (Object.prototype.hasOwnProperty.call(src, prop)) {
            if (prop.endsWith("_f") || prop.endsWith("_error")) continue;
            target[prop] = src[prop];
        }
    }
    return target;
};

Vue.prepare_form_data = function (data, field_types) {
    for (let prop in field_types) {
        if (!Object.prototype.hasOwnProperty.call(field_types, prop)) continue;

        if (data[prop] === undefined) data[prop] = null;

        data[prop + "_error"] = null;

        switch (field_types[prop]) {
            case "number":
                data[prop + "_f"] = data[prop] != null ? formatNumber(data[prop]) : "";
                break;
            case "integer":
                data[prop + "_f"] = data[prop] != null ? formatNumber(data[prop]) : "";
                break;
            case "money":
                data[prop + "_f"] = data[prop] != null ? formatMoneyNumber(data[prop]) : "";
                break;
            case "date":
                data[prop + "_f"] = data[prop] != null ? formatDate(data[prop]) : "";
                break;
            case "datetime":
                data[prop + "_time_error"] = null;
                if (data[prop] == null) {
                    data[prop + "_f"] = "";
                    data[prop + "_time"] = null;
                    data[prop + "_time_f"] = null;
                } else {
                    data[prop + "_f"] = formatDateTime(data[prop]);
                    data[prop + "_time"] = formatSysTime(data[prop]);
                    data[prop + "_time_f"] = formatTime(data[prop]);
                }
                break;
            case "time":
                data[prop + "_f"] = data[prop] != null ? formatTimeFromStr(data[prop]) : "";
                break;
            case "reference":
                data[prop + "_f"] = data[prop] != null ? data[prop] : null;
                break;
        }
    }

    return data;
};
//todo: move to helpers
export const syncItemChanges = function (item, changes) {
    for (let prop in changes) {
        if (Object.prototype.hasOwnProperty.call(changes, prop)) {
            item[prop] = changes[prop];
        }
    }
};
export const syncItemChangesDeep = function (item, changes) {
    for (let prop in changes) {
        if (Object.prototype.hasOwnProperty.call(changes, prop)) {
            if (typeof changes[prop] === "object" && item[prop] !== undefined && changes[prop] !== null) {
                syncItemChangesDeep(item[prop], changes[prop]);
            } else {
                item[prop] = changes[prop];
            }
        }
    }
};
//todo: move to helpers
export const syncItemToList = function (list, item, field = "id", as_first = false) {
    for (let l = 0; l < list.length; l++) {
        if (item[field] === list[l][field]) {
            syncItemChanges(list[l], item);
            return;
        }
    }
    if (as_first)
        list.unshift(item);
    else
        list.push(item);
};
//todo: remove
Vue.sync_to_list = function (collection, item) {
    for (var i in collection) {
        if (collection[i].id === item.id) {
            Vue.set(collection, i, item);
            return;
        }
    }
    collection.push(item);
};
//todo: move to helpers
export const syncItemsToList = function (list, items) {
    for (let i = 0; i < items.length; i++) {
        let found = false;
        for (let l = 0; l < list.length; l++) {
            if (items[i].id === list[l].id) {
                syncItemChanges(list[l], items[i]);
                found = true;
                break;
            }
        }
        if (!found) {
            list.push(items[i]);
        }
    }
};
//todo: move to helpers
export const removeItemsFromList = function (list, item_id_list) {
    for (let i = list.length - 1; i >= 0; i--) {
        if (item_id_list.indexOf(list[i].id) >= 0) {
            list.splice(i, 1);
        }
    }
};
//todo: move to helpers
export const removeFromList = function (list, item_id, field = "id") {
    for (let i = 0; i < list.length; i++) {
        if (list[i][field] === item_id) {
            list.splice(i, 1);
            return;
        }
    }
};
//todo: remove
Vue.sync_item_changes = function (obj, changes, syncId = false) {
    syncItemChanges(obj, changes, syncId);
};
//todo: remove
Vue.remove_from_list = function (collection, item_id) {
    for (let i = 0; i < collection.length; i++) {
        if (collection[i].id === item_id) {
            collection.splice(i, 1);
            return;
        }
    }
};

Vue.remove_item_from_list = function (collection, fx_equals) {
    for (let i = collection.length - 1; i >= 0; i--) {
        if (fx_equals(collection[i])) {
            collection.splice(i, 1);
        }
    }
};

export const formatChoiceValue = (field, val) => {
    if (val === undefined || val == null) return "";
    if (field.choices === undefined || field.choices == null) return val;
    let valObj = field.choices.find(x => x.code === val);
    return valObj == null ? val : valObj.name;
};
export const formatMultiChoiceValue = (field, val_list) => {
    if (val_list === undefined || val_list == null) return "";
    return val_list.map(x => formatChoiceValue(field, x)).join(", ");
}

export const formatByHeader = function (value, header) {
    if (["extra_h", "total_h", "billable_h", "non_billable_h"].includes(header.value)) {
        return (value / (60 * 60)).toFixed(4);
    } else if (header.type === "time") {
        return formatTimeDuration(value);
    } else if (header.type === "price") {
        return formatMoneyNumber(value);
    }
    return value;
};
